import React from "react";

const EmailIcon = ({ highlighted }) => {
  return (
    <img
      className="h-[1.1rem] w-[1.1rem]"
      src={
        highlighted
          ? require("../assets/Group-7.png")
          : require("../assets/Group-6.png")
      }
    />
  );
};

export default EmailIcon;
